import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-suggested-consultants.tsx
var LazySuggestedConsultants = lazy(() => import("./suggested-consultants-CCOdq2zj.js").then((n) => n.n).then((module) => ({ default: module.SuggestedConsultants })));
function SuggestedConsultants({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "suggested-consultants" }),
		children: /* @__PURE__ */ jsx(LazySuggestedConsultants, { ...props })
	});
}
function SuggestedConsultantsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "suggested-consultants" }),
		children: /* @__PURE__ */ jsx(LazySuggestedConsultants, { ...props })
	});
}
var useSuggestedConsultantsContent = () => {
	return useMemo(() => ({ suggestedConsultants: { component: SuggestedConsultantsContent } }), []);
};
//#endregion
export { SuggestedConsultants, useSuggestedConsultantsContent };
